import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Styles/content.css';
import Productpage from './Productpage';
function Contenth({setproductd,content}) {
  const slideri = [
      {id:1,
      icon:'https://images-eu.ssl-images-amazon.com/images/G/31/img22/Baby/cnnjpp1/Baby/D92807365-_1_Tallhero_2xx._CB598669664_.jp'},
      {id:1,
      icon:'https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Shreyansh/BAU/Unrexc/D70978891_INWLD_BAU_Unrec_Uber_PC_Hero_3000x1200._CB594707876_.jpg'},
      {id:3,
      icon:'https://images-eu.ssl-images-amazon.com/images/G/31/img2020/img21/apparelGW/augatf23/unrec/fed/MA_3000._CB597336535_.jpg'},
      {id:4,
      icon:'https://images-eu.ssl-images-amazon.com/images/G/31/img18/Lawn_Garden/Ud/July2023/Monsoongd/August/GW/GW-heros-Pc-1_3000x1200._CB597354947_.jpg'},
      {id:5,
      icon:'https://images-eu.ssl-images-amazon.com/images/G/31/img17/Home/AmazonTV/MyFirstLove/PC_Hero/3000x1200_My-Frist-Love_V3._CB597195052_.jpg'}
  
  ]  
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
  return (
    <>
    <div className="slider max-width">

    <Slider {...settings}>
  {slideri.map((item)=>{
    return <div className='cs'><img src={item.icon} alt={item.id} /></div>
  }) }
    </Slider>
    </div>
    <div className='content max-width'>
   <Productpage content = {content} setproductd={setproductd}/>
<div className='chat-i'>
  <img src="https://tse2.mm.bing.net/th?id=OIP.ZfTuS_Nd4aW-q8ja9Lh48AHaFj&pid=Api&P=0&h=180" alt="" className='chat' />
</div>
    </div>
    </>
  )
} 

export default Contenth
